export default __webpack_public_path__ + "react/static/phone-step-thumb-a33d3970d480d1fc763683c4a8b36d27.png";